import { createGtm, useGtm } from "@gtm-support/vue-gtm";
import { defineNuxtPlugin, useRuntimeConfig, useRouter, useRoute } from "#app";
import { watch } from "vue";
export default defineNuxtPlugin((nuxtApp) => {
  const config = useRuntimeConfig();
  if (config.public.gtmId) {
    nuxtApp.vueApp.use(createGtm({
      id: config.public.gtmId,
      defer: true,
      compatibility: true,
      enabled: false,
      debug: config.public.debug ?? false,
      loadScript: true,
      vueRouter: useRouter(),
      trackOnNextTick: true,
      trackViewEventProperty: "nuxt_page_view"
    }));
  }
  const gtm = useGtm();
  const enable = () => {
    if (gtm) {
      gtm.enable(true);
      const route = useRoute();
      gtm.trackView(route.name, route.path);
    }
  };
  const disable = () => {
    if (gtm) {
      gtm.enable(false);
    }
  };
  const track = (object) => {
    if (gtm) {
      window.dataLayer?.push(object);
    }
  };
  const trackEcommerceEvent = (event, ecommerceData) => {
    track({ ecommerce: null });
    track({
      event,
      ecommerce: ecommerceData
    });
  };
  if (nuxtApp.$auth) {
    watch(() => nuxtApp.$auth.user, (user) => {
      let userRole = "guest";
      if (user) {
        if (user.roles.includes("admin")) {
          userRole = "admin";
        } else {
          userRole = "user";
        }
      }
      track({
        user_role: userRole
      });
    }, { immediate: true });
  }
  return {
    provide: {
      analytics: {
        enable,
        disable,
        track,
        trackEcommerceEvent
      }
    }
  };
});
